export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=702f5dcc211e4218bbe99c4535361ad1a0c37c2aee&name=pushAdClickData!'